import Vue from 'vue'
import Router from 'vue-router'
import BookList from '@/views/BookList'
import WordList from '@/views/WordList'
import RecordPractice from '@/views/RecordPractice'
import StudyRecord from '@/views/StudyRecord'
import SentencePractice from '@/views/SentencePractice'
import StoryPractice from '@/views/StoryPractice'
import WordRecordDetail from '@/views/WordRecordDetail'
import StoryRecordDetail from '@/views/StoryRecordDetail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/books'
    },
    {
      path: '/books',
      name: 'BookList',
      component: BookList
    },
    {
      path: '/books/:id',
      redirect: to => `/story-practice/${to.params.id}`
    },
    {
      path: '/books/:id/story-practice',
      redirect: to => `/story-practice/${to.params.id}`
    },
    {
      path: '/story-practice/:bookId',
      name: 'StoryPractice',
      component: StoryPractice
    },
    {
      path: '/books/:id/words',
      name: 'WordList',
      component: WordList
    },
    {
      path: '/books/:id/words/:wordId/record',
      name: 'RecordPractice',
      component: RecordPractice
    },
    {
      path: '/records',
      name: 'StudyRecord',
      component: StudyRecord
    },
    {
      path: '/records/story/:id',
      name: 'StoryRecordDetail',
      component: StoryRecordDetail
    },
    {
      path: '/records/word/:id',
      name: 'WordRecordDetail',
      component: WordRecordDetail
    },
    {
      path: '/sentence',
      name: 'SentencePractice',
      component: SentencePractice
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js